import { render, staticRenderFns } from "./ProveedoresList.vue?vue&type=template&id=e55fe6c6&"
import script from "./ProveedoresList.vue?vue&type=script&lang=js&"
export * from "./ProveedoresList.vue?vue&type=script&lang=js&"
import style0 from "./ProveedoresList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports